import { Grid } from "@mui/material";
import { FC, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { H4 } from "../../components/Typography";

const PaymentScreen: FC = () => {
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();
  setTimeout(() => {
    const url = new URL(window.location.href);
    const orderid: any = url.searchParams.get("ORDER_ID");
    navigate("/paymentSucess", {
      state: {
        orderid: orderid,
      },
    });
    setLoading(false);
  }, 10000);

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress />
      <H4 sx={{ mt: 2 }}>We are processing your Payment</H4>
      <H4>Please wait</H4>
    </Grid>
  );
};

export default PaymentScreen;
